import { globalApi as api } from '../../api';

export const companyDetailsDataInput = async (CompanyDetailsInput) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/create_company_details', CompanyDetailsInput, {
      headers: {
        'Authorization': `Bearer ${token}`,
        // 'Content-Type': 'multipart/form-data'
      }
    });
    console.log(response);
    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    console.log(error);
    throw error.response ? error.response.data.error : error.message;
  }
};

export const fetchCompanyDetails = async (company_code) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.get(`/get_company_details/${company_code}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};


export const fetchAllCompanyDetails = async () => {
  try {
    const token = sessionStorage.getItem('token');
    const user = sessionStorage.getItem('user');
    const company_code = user ? JSON.parse(user).company_code : null;
    const response = await api.get(`/get_all_company_details`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const updateCompanyDetails = async (id, companyDetailsData) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.put(`/update_company_details/${id}`, companyDetailsData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const deleteCompanyDetails = async (id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.delete(`/delete_company_details/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};


